export default "__VITE_ASSET__YQLfiJ2T__"